import { getToken } from '../util/storage';

const TELEM_URL = process.env.REACT_APP_TELEM_URL || '/api/vehicle-telem';

async function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }

  return response.json();
}

export async function getLatestTelemetry(vehicleId) {
  return fetchWithAuth(`${TELEM_URL}/vehicles/${vehicleId}/telemetry/latest`);
}
